/* global swal, axios, Plyr */

var page = { player: null },
    pathArray = window.location.pathname.split("/"),
    slugIndex = pathArray.indexOf("e") + 1,
    slug = pathArray[slugIndex];

function makeApiCall() {
    return axios
        .get("https://api.cyberdrop.me/api/file/info/" + slug)
        .then(function (response) {
            if (!response.data) {
                swal("An error occurred!", "File details not found", "error");
            } else {
                getAuthUrl(response.data.auth_url, response.data);
            }
        })
        .catch(function (error) {
            console.error("Error caught in makeApiCall:", error);
            swal("Error", "An unknown error occurred", "error");
        });
}

function getAuthUrl(authUrl, fileInfo) {
    return axios
        .get(authUrl)
        .then(function (response) {
            if (response.data.url) {
                embedVideo(response.data.url, fileInfo);
            } else {
                swal("An error occurred!", "Video URL not found", "error");
            }
        })
        .catch(function (error) {
            console.error("Error caught in getAuthUrl:", error);
            swal("Error", "An unknown error occurred", "error");
        });
}

function embedVideo(videoUrl, fileInfo) {
    if (fileInfo.type.startsWith("video")) {
        var r = document.getElementById("video-container");
        if (r) {
            var o = document.createElement("video");
            o.id = "player";
            o.className = "plyr__video-embed";
            o.setAttribute("controls", "");
            o.setAttribute("preload", "none");
            if (document.referrer) {
                try {
                    if (new URL(document.referrer).hostname.includes("simpcity.su")) {
                        o.setAttribute("poster", fileInfo.thumbnail_url);
                    }
                } catch (e) {
                    console.error("Error processing document.referrer:", e.message);
                }
            }
            o.innerHTML = '<source src="' + videoUrl + '" type="' + fileInfo.type + '">';
            r.innerHTML = "";
            r.appendChild(o);

            page.player = new Plyr("#player", {
                debug: false,
                tooltips: { controls: true },
                controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "fullscreen"],
                autoplay: false,
                ratio: "16:9"
            });

            page.player.on("ready", function (e) {
                var r = document.createElement("button");
                r.className = "plyr__control";
                r.innerHTML = '<i class="fas fa-download"></i>';
                r.title = "Download";
                r.addEventListener("click", function () {
                    var e = window.location.pathname.split("/").pop();
                    window.open("https://cyberdrop.me/f/" + e, "_blank");
                });
                var o = document.querySelector(".plyr__controls");
                o ? o.appendChild(r) : console.error("Plyr controls container not found");
            });

            var t = document.querySelector(".plyr__controls .plyr__control--overlaid"),
                n = document.createElement("div");
            n.classList.add("custom-logo");
            n.innerHTML = '<img title="homer is drunk" src="https://cyberdrop.me/images/logo_footer.gif" alt="Logo" style="height: 30px;">';
            t && t.nextSibling ? t.parentNode.insertBefore(n, t.nextSibling) : document.querySelector(".plyr__controls").appendChild(n);
        } else {
            console.error("Video container not found");
        }
    } else {
        window.location.href = "/f/" + fileInfo.slug;
    }
}

page.lastVisit = function () {
    return axios
        .post("../api/f/last_visit", { type: "file", fileid: page.file.id })
        .then(function (response) {
            if (!response.data.success) {
                return swal("An error occurred!", response.data.description, "error");
            }
        })
        .catch(page.onInitError);
};

window.addEventListener("DOMContentLoaded", function () {
    makeApiCall();
});
